/**
 * 站點聯絡資訊（fallback）
 * 學生端顯示優先使用網站文案 homePage.contact*（後台「關於我們 → 聯絡資訊」）；
 * 此檔供名稱常數、中心官網連結，以及文案未覆寫時的預設參考。
 */
export const SITE_CONTACT = {
  name: 'EMI Center',
  address: '高雄市鼓山區蓮海路70號，圖資大樓10樓西灣學院',
  phone: '07-5252000 # 5808/5876',
  email: 'emicenter@mail.nsysu.edu.tw',
  hours: 'Mon–Fri 09:00–17:00',
};

export const EMI_CENTER_URL = 'https://emicenter.siwan.nsysu.edu.tw/';
